import { render } from "./checkUserButtonModel.vue?vue&type=template&id=06427205"
import script from "./checkUserButtonModel.vue?vue&type=script&lang=js"
export * from "./checkUserButtonModel.vue?vue&type=script&lang=js"

import "./checkUserButtonModel.vue?vue&type=style&index=0&id=06427205&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__